import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Image, Button } from "react-bootstrap";
import moment from "moment";
import CallingButtonPopup from "../../allPopupReusable/CallingButtonPopup";
import SendSmsButton from "../../allPopupReusable/SendSmsButton";
import NotificationButton from "../../allPopupReusable/NotificationButton";
import Timer from "react-compound-timer";
// import { PopupIconButtonReusable } from "../../allPopupReusable/allPopupReusableIconButton/PopupIconButtonReusable";
// import ViewButtonPopup from "../../allPopupReusable/ViewButtonPopup";
// import EditDiner from "../../allPopupReusable/editDinerAndEditReservaion/EditDiner";
import DeletePopup from "../../allPopupReusable/smallPopup/DeletePopup";
import LocationReusable from "../../allPopupReusable/locationReusablePopup/LocationReusable";
import EditDiner from "../../../vendorDashboardComponents/seatingDashboard/EditDiner";
import ViewDiner from "../../../vendorDashboardComponents/seatingDashboard/ViewDiner";
import EditWaitTime from "../../allPopupReusable/tableNumberPopup/EditWaitTime";
import ChatWindow from "../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/ChatWindow";
import NewCountDown from "../../allPopupReusable/tableNumberPopup/NewCountDown";
import isEmpty from "../../../../store/validation/is-Empty";
import { useHistory } from "react-router-dom";
import CallingIconButtonActionFile from "../../allPopupReusable/tableNumberPopup/CallingIconButtonAction/CallingIconButtonActionFile";

export const PendingDashboardBody = (props) => {
  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(props.dinerInfo.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  const history = useHistory();

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  var date1 = new Date();
  var date2 = new Date(props.dinerInfo.createdAt);
  // .getDate();
  var date3 =
    props?.dinerInfo?.reservationTime !== undefined &&
    props?.dinerInfo?.reservationTime !== null
      ? new Date(props?.dinerInfo?.reservationTime)
      : new Date();
  // .getTime();

  const walkinWaitlistAutoCancelTime = useSelector(
    (state) =>
      state.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.seating?.walkin_waitlist?.auto_cancel
  );
  const reservationAutoCancelTime = useSelector(
    (state) =>
      state.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.seating?.reservation?.auto_cancel
  );

  const [diffTime, setDiffTime] = useState(0);
  useEffect(() => {
    if (!isEmpty(walkinWaitlistAutoCancelTime)) {
      const walkinWaitlistminute = walkinWaitlistAutoCancelTime;
      const reservationMinute = reservationAutoCancelTime;

      // const updatedTime = new Date(props.dinerInfo.wait_time_date);
      const currentTimeTwo = new Date().getTime();
      // const updatedTimeNew = updatedTime.getTime();
      // const waitTime = props.dinerInfo.wait_time * 60 * 1000;
      // let updateWaitTime = updatedTimeNew + waitTime;
      // let diff = updateWaitTime - currentTimeTwo;
      // setDiffTime(diff);
      const updatedTime = moment(
        props?.dinerInfo?.wait_time_date
        //  || props?.dinerInfo?.OrderAcceptTime
      ).add(parseInt(props.dinerInfo?.wait_time), "minutes");
      let diff = new Date(updatedTime).getTime() - currentTimeTwo;
      setDiffTime(diff);
    }
  }, [walkinWaitlistAutoCancelTime]);

  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  const [open, setState] = useState(false);
  const onCloseModal = () => {
    setState(!open);
  };

  let vendorId = JSON.parse(localStorage.getItem("vendorId"));
  let subscriptionId = JSON.parse(localStorage.getItem("subscriptionId"));
  const [editWaitTimeModel, seteditWaitTimeModel] = useState(false);
  const changeEditWaitTimeModel = () => seteditWaitTimeModel(false);
  const openEditWaitTimeModel = () => seteditWaitTimeModel(true);

  return (
    <React.Fragment>
      <tbody className="w-100 seating-dashboard-body-new">
        <tr className="w-100 p-0">
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody className="sd_body_css">
                <tr
                  className={`cursor sd_body_tr ${
                    props.dinerInfo.service_type === "RESERVATION"
                      ? "td_b_o"
                      : "td_b_g"
                  }`}
                  onClick={showTr}
                >
                  <td
                    className={
                      props.dinerInfo.isWalkIn === true ||
                      props.dinerInfo.isWalkIn === false
                        ? "td_b_g order-type-Image"
                        : "td_b_o order-type-Image"
                    }
                    style={{ width: "6%" }}
                  >
                    {props.dinerInfo.isWalkIn === true &&
                    props.dinerInfo.service_type === "SEATING" ? (
                      <Image
                        src={require("../../../../assets/images/ActionImages/image/walkin.svg")}
                        alt="Order Type"
                        title="Order Type"
                        width="28px"
                      />
                    ) : null ||
                      (props.dinerInfo.isWalkIn === false &&
                        props.dinerInfo.service_type === "SEATING") ? (
                      <Image
                        src={require("../../../../assets/images/ActionImages/image/waitlist.svg")}
                        alt="Order Type"
                        title="Order Type"
                        width="28px"
                      />
                    ) : null ||
                      props.dinerInfo.service_type === "RESERVATION" ? (
                      <Image
                        src={require("../../../../assets/images/ActionImages/image/reservation.svg")}
                        alt="Order Type"
                        title="Order Type"
                        width="28px"
                      />
                    ) : null}
                  </td>
                  <td style={{ width: "20%" }}>
                    <h4 className="font_20_m">{props.dinerName}</h4>
                    <p className="font_12_r">#{props.dinerInfo.diner_id}</p>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="total-pax-body">
                      <div className="col d-flex p-0">
                        <div className="total-pax-body-inside">
                          <h4 className="font_24_b">
                            {props.dinerInfo.adult_count +
                              props.dinerInfo.kids_count}
                          </h4>
                          {/* <p className="total-pax-light-text">PAX</p> */}
                        </div>
                        <div className="total-adult-kids">
                          {props.dinerInfo.adult_count === 0 ? null : (
                            <div className="display-align">
                              <Image
                                src={require("../../../../assets/images/ActionImages/image/adult.svg")}
                                alt="Adult"
                                title="Adult"
                                className="pax-type-Image"
                              />
                              <p className="font_12_m ml-1 mr-1">
                                {props.dinerInfo.adult_count}
                              </p>
                            </div>
                          )}
                          {props.dinerInfo.kids_count === 0 ? null : (
                            <div className="display-align">
                              <Image
                                src={require("../../../../assets/images/ActionImages/image/kids.svg")}
                                alt="Kids"
                                title="Kids"
                                className="pax-type-Image"
                              />
                              <p className="font_12_m ml-1 mr-1">
                                {props.dinerInfo.kids_count}
                              </p>
                            </div>
                          )}
                        </div>
                        <div className="total-highchair-handicapp">
                          {props.dinerInfo.high_chair === 0 ? null : (
                            <div className="display-align">
                              <Image
                                src={require("../../../../assets/images/ActionImages/image/highchair.svg")}
                                alt="Highchair"
                                title="Highchair"
                                className="pax-type-Image"
                              />
                              <p className="font_12_m ml-1 mr-1">
                                {props.dinerInfo.high_chair}
                              </p>
                            </div>
                          )}
                          {props.dinerInfo.handicap_chair === 0 ? null : (
                            <div className="display-align">
                              <Image
                                src={require("../../../../assets/images/ActionImages/image/handicap.svg")}
                                alt="Handicapped"
                                title="Handicapped"
                                className="pax-type-Image"
                              />
                              <p className="font_12_m ml-1 mr-1">
                                {props.dinerInfo.handicap_chair}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="date-time-timer-body">
                      <div className="time-and-edit-button">
                        <EditWaitTime
                          allDataProps={props.dinerInfo._id}
                          noDisplay={
                            <div className="timer-section mr-2">
                              <h4
                                className="f14-700"
                                style={{ color: "#EE3A23" }}
                              >
                                {/* {diffTime !== 0 ? (
                                          // <Timer
                                          //   initialTime={diffTime < 0 ? 0 : diffTime}
                                          //   formatValue={(value) =>
                                          //     `${value < 10 ? `0${value}` : value}`
                                          //   }
                                          //   lastUnit="h"
                                          //   direction="backward"
                                          // >
                                          //   {() => (
                                          //     <React.Fragment>
                                          //       {/* <Timer.Days /> days 
                                          //       <Timer.Hours /> :
                                          //       <Timer.Minutes /> :
                                          //       <Timer.Seconds />
                                          //       {/* <Timer.Milliseconds /> milliseconds 
                                          //     </React.Fragment>
                                          //   )}
                                          // </Timer>
                                          <NewCountDown waitNew={diffTime} />
                                        ) : null} */}
                                <NewCountDown waitNew={diffTime} />
                              </h4>
                            </div>
                          }
                          openFromParent={changeEditWaitTimeModel}
                          changeEditWaitTimeModel={changeEditWaitTimeModel}
                        />
                      </div>
                    </div>
                    {/* <h4 className="font_20_m mb-3">
                      {props.dinerInfo.diner_status}
                    </h4> */}
                    <p className="font_20_r">
                      {props.dinerInfo.service_type === "RESERVATION"
                        ? moment(props.dinerInfo.reservationTime).format(
                            "Do MMM YYYY"
                          )
                        : moment(props.dinerInfo.createdAt).format(
                            "Do MMM YYYY"
                          )}
                    </p>
                    <p className="font_20_r">
                      {props.dinerInfo.service_type === "RESERVATION"
                        ? moment(props.dinerInfo.reservationTime).format(
                            "hh:mm A"
                          )
                        : moment(props.dinerInfo.createdAt).format("hh:mm A")}
                    </p>
                  </td>
                  <td style={{ width: "15%" }}>
                    <h4 className="font_20_m">
                      {props.dinerInfo.seating_preference[0]}
                    </h4>
                  </td>
                  <td style={{ width: "15%" }}>
                    <h4 className="font_20_m">{time_convert(minutes)}</h4>
                  </td>
                  <td style={{ width: "32%" }}>
                    <div
                      className={
                        props.displayInfo === "SUPERADMIN"
                          ? "action-section-body justify-content-center"
                          : "action-section-body f10-500"
                      }
                    >
                      {props.displayInfo === "SUPERADMIN" ? (
                        ""
                      ) : (
                        <div>
                          <DeletePopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="resonFforCancellation"
                            actionCall={"pendingSide"}
                            // noReason
                            buttonText="Reject"
                            bigText="Request Reject"
                            reasonText="Are you sure to Reject ?"
                            dataSend={props.dinerInfo._id}
                            dataSendOne={props.dinerInfo}
                            actionBy={props.actionPerformBy}
                            pathAction="HISTORY"
                            adminSendVendorId={vendorId}
                            IconButton={require("../../../../assets/images/iconButton/crossred.svg")}
                            cancelRequest="SeatingReject"
                          />
                        </div>
                      )}
                      <div className="middle-timer m-0">
                        {/* <p className="font_12_r mb-2">Total Wait time</p> */}
                        {/* <div className="count-down-timer">
                            <p className="total-wait-time-hour">
                              {time_convert(minutes)}
                              {/* <span>hh</span> : 20 <span>mins</span> *
                            </p>
                          </div> */}
                        <div
                          className="count-down-timer"
                          style={{
                            backgroundColor: "#FFF6DF",
                            color: "#E2A200",
                          }}
                        >
                          {/* <i
                            className="fa fa-hourglass-half mr-3"
                            aria-hidden="true"
                          ></i> */}
                          <p className="font_16_m">
                            {props.dinerInfo.diner_status}
                          </p>
                        </div>
                        {/* <p className="font_16_r">
                          Status:&nbsp;
                          <span className="font_16_b">
                            {props.dinerInfo.diner_status}
                          </span>
                        </p> */}
                      </div>
                      {props.displayInfo === "SUPERADMIN" ? (
                        ""
                      ) : (
                        <div>
                          {props.dinerInfo.service_type === "RESERVATION" ? (
                            props.dinerInfo.service_type === "RESERVATION" &&
                            date3 < date1.getTime() ? (
                              ""
                            ) : (
                              <DeletePopup
                                buttonDisplay="acceptButtonReservation"
                                // displayPopup="acceptButtonReservation"
                                buttonText="Accept"
                                bigText="Request Accept"
                                reasonText="Are you sure you want to accept ?"
                                dataSend={props.dinerInfo}
                                actionBy={props.actionPerformBy}
                                pathAction="HISTORY"
                                adminSendVendorId={vendorId}
                                IconButton={require("../../../../assets/images/iconButton/Checkgreen.svg")}
                              />
                            )
                          ) : props.dinerInfo.service_type === "SEATING" &&
                            date2 < date1.getDate() ? (
                            ""
                          ) : (
                            <EditWaitTime
                              buttonText="Accept"
                              editButtonStatus="pendingEdit"
                              closedMainModal={onCloseModal}
                              allDataProps={props.dinerInfo._id}
                              actionBy={props.actionPerformBy}
                              pathAction="HISTORY"
                              adminSendVendorId={vendorId}
                              IconButton={require("../../../../assets/images/iconButton/Checkgreen.svg")}
                            />
                          )}
                        </div>
                      )}
                    </div>
                    {/* <div
                        className={
                          props.displayButton === true
                            ? "action-section-body d-flex align-items-center justify-content-center"
                            : "action-section-body align-items-center"
                        }
                      >
                        {props.dinerInfo.diner_status === "SEATED" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="seatingUnseated"
                              buttonText="Unseat"
                              bigText="Are you sure to Unseat ?"
                              dataSend={props.dinerInfo}
                              actionBy={props.actionPerformBy}
                              pathAction="HISTORY"
                              adminSendVendorId={vendorId}
                            />
                          </div>
                        ) : (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="resonFforCancellation"
                              actionCall={"seatingDashboardSide"}
                              buttonText="Cancel"
                              bigText="Are you sure to Cancel ?"
                              dataSend={props.dinerInfo._id}
                              actionBy={props.actionPerformBy}
                              pathAction="HISTORY"
                              adminSendVendorId={vendorId}
                            />
                          </div>
                        )}
                        <div className="middle-timer">
                          <p className="font_12_r">Total Wait time</p>
                          <div className="count-down-timer d-flex">
                            <i
                              className="fa fa-hourglass-half mr-3"
                              aria-hidden="true"
                            ></i>
                            <p className="font_16_m">
                              {props.dinerInfo.diner_status === "NOTSEATED"
                                ? time_convert(minutes)
                                : seated_time_difference(minutesSeated)}
                            </p>
                          </div>
                          <p className="font_20_r">
                            Status:&nbsp;
                            <span className="font_20_b">
                              {props.dinerInfo.diner_status === "NOTSEATED"
                                ? "NOT SEATED"
                                : "SEATED"}
                            </span>
                          </p>
                        </div>
                        {props.dinerInfo.diner_status === "SEATED" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallSaveButton"
                              displayPopup="seatingCompleted"
                              buttonText="Complete"
                              bigText="Are you sure to Completed ?"
                              dataSend={props.dinerInfo}
                              actionBy={props.actionPerformBy}
                              pathAction="HISTORY"
                              adminSendVendorId={vendorId}
                            />
                          </div>
                        ) : (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallSaveButton"
                              displayPopup="SeatedButton"
                              buttonText="Seat"
                              bigText="Are you sure to Seated ?"
                              dataSend={props.dinerInfo._id}
                              actionBy={props.actionPerformBy}
                              pathAction="HISTORY"
                              adminSendVendorId={vendorId}
                            />
                          </div>
                        )}
                      </div> */}
                  </td>
                </tr>
                {TrDetail.TrDetail && (
                  <tr className="sd_accordion_body">
                    <td className="sd_accordion_td_1">
                      <h4 className="font_20_m c_red">More details</h4>
                      <div className="d-flex justify-content-between mt-3 mr-3">
                        {props.displayCall === true ? (
                          // <CallingButtonPopup
                          //   buttonClass="smallButton"
                          //   sendData={props.dinerInfo}
                          // />
                          <CallingIconButtonActionFile
                            orderDetails={props.dinerInfo?.user_details}
                            actionType="conbinedName"
                          />
                        ) : null}
                        {props.displaySms === true ? (
                          <SendSmsButton
                            dataSend={props.dinerInfo}
                            buttonClass="smallButton"
                          />
                        ) : null}
                        {props.displayNotification === true ? (
                          <NotificationButton
                            buttonClass="smallButton"
                            dataSend={props.dinerInfo}
                          />
                        ) : null}
                        {props.displayChat === true ? (
                          <ChatWindow
                            data={props.dinerInfo}
                            text={props.actionBy}
                          />
                        ) : null}
                        {console.log(
                          "Date 1 ===>",
                          date1,
                          "Date 2 ===>",
                          date2,
                          "Date 3 ===>",
                          date3
                        )}
                        {props.displayViewDiner === true ? (
                          // <ViewButtonPopup
                          //   dataSend={props.dinerInfo}
                          //   buttonClass="smallButton"
                          // />
                          <ViewDiner
                            actionByData={props.actionBy}
                            dataSend={props.dinerInfo}
                            displayData={props.displayInfo}
                            displayButton="PENDING"
                            date1={date1}
                            date2={date2}
                            date3={date3}
                            onCloseModal={onCloseModal}
                            viewActionPerformBy={props.actionPerformBy}
                            viewVendorId={vendorId}
                            subscription_id={
                              props.actionPerformBy === "ADMIN"
                                ? subscriptionId
                                : props.subscription_id
                            }
                            auth={props.auth.user?.VendorUser?.role}
                          />
                        ) : null}
                        {props.displayEditDiner === true ? (
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              history.push({
                                pathname: `/seatingdashboard/editdiner/${props.dinerInfo?.diner_id}`,
                                state: { dinerInfo: props.dinerInfo },
                              })
                            }
                          >
                            <Image
                              src={require("../../../../assets/images/UserManagement/pencil.svg")}
                              alt="Edit"
                              title="Edit"
                              fluid
                            />
                          </Button>
                        ) : // <EditDiner
                        //   actionByData={props.actionBy}
                        //   buttonClass="smallButton"
                        //   dataSend={props.dinerInfo}
                        //   bigText="Edit Diner"
                        //   displayData={props.displayInfo}
                        //   displayButton="PENDING"
                        //   date1={date1}
                        //   date2={date2}
                        //   date3={date3}
                        //   onCloseModal={onCloseModal}
                        //   viewActionPerformBy={props.actionPerformBy}
                        //   viewVendorId={vendorId}
                        //   subscription_id={
                        //     props.actionPerformBy === "ADMIN"
                        //       ? subscriptionId
                        //       : props.subscription_id
                        //   }
                        // />
                        null}
                      </div>
                    </td>
                    <td className="sd_accordion_td_2">
                      {props.auth.user?.VendorUser?.role !== "vendor" ? (
                        <></>
                      ) : (
                        <>
                          <h4 className="font_20_m">Track User Location</h4>
                          <LocationReusable
                            dataSend={props.dinerInfo}
                            disabled={
                              props.dinerInfo.service_type === "RESERVATION" &&
                              moment(props.dinerInfo.reservationTime).format(
                                "Do MMM YYYY"
                              ) !== moment().format("Do MMM YYYY")
                                ? true
                                : false
                            }
                          />
                        </>
                      )}
                    </td>
                    <td className="sd_accordion_td_3">
                      <h4 className="font_20_m">Date & Time</h4>
                      <div className="mt-3">
                        <p className="font_16_r">
                          {props.dinerInfo.service_type === "RESERVATION"
                            ? moment(props.dinerInfo.reservationTime).format(
                                "Do MMM YYYY"
                              )
                            : moment(props.dinerInfo.createdAt).format(
                                "Do MMM YYYY"
                              )}
                        </p>
                        <p className="font_16_r">
                          {props.dinerInfo.service_type === "RESERVATION"
                            ? moment(props.dinerInfo.reservationTime).format(
                                "hh:mm A"
                              )
                            : moment(props.dinerInfo.createdAt).format(
                                "hh:mm A"
                              )}
                        </p>
                      </div>
                    </td>
                    <td className="sd_accordion_td_4">
                      <h4 className="font_20_m">Table / Room No.</h4>
                      <div className="mt-3">
                        <p className="font_16_r">
                          {props?.dinerInfo?.room_number === null ||
                          props?.dinerInfo?.room_number === undefined ||
                          props?.dinerInfo?.room_number === ""
                            ? ""
                            : `Room No. - ${props?.dinerInfo?.room_number}`}
                        </p>
                        <p className="font_16_r">
                          {props?.dinerInfo?.table_number === null ||
                          props?.dinerInfo?.table_number === undefined ||
                          props?.dinerInfo?.table_number === ""
                            ? ""
                            : `Table No. - ${props?.dinerInfo?.table_number}`}
                        </p>
                      </div>
                    </td>
                    <td className="sd_accordion_td_5">
                      <div
                        className="d-flex mt-3"
                        style={{ wordBreak: "break-word" }}
                      >
                        <p
                          className="font_16_r"
                          style={{ wordBreak: "break-word" }}
                        >
                          {props.dinerInfo.occasion}
                          {/* {props.dinerInfo.occasion.length > 65 ? (
                            <span className="c_orange">&nbsp;see more</span>
                          ) : (
                            ""
                          )} */}
                        </p>
                      </div>
                    </td>
                    <td className="sd_accordion_td_6">
                      <h4 className="font_20_m">Status</h4>
                      <div className="d-flex mt-3">
                        <div className="b_c_orange status_blink_box"></div>
                        <p className="font_16_m">
                          {props.dinerInfo.diner_status}
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </React.Fragment>
  );
};
